// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3l5xW","row":"styles_row___rmTO"};